import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Lazy load translations
const loadTranslations = async (language: string) => {
  try {
    const translation = await import(`./locales/${language}.json`);
    return translation.default;
  } catch (error) {
    console.error(`Failed to load ${language} translations:`, error);
    // Fallback to English if loading fails
    const fallback = await import('./locales/en.json');
    return fallback.default;
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {} // Start with empty English resources to prevent blocking
      }
    },
    lng: 'en',
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    // Don't wait for translations to load before rendering
    initImmediate: false,
    // Render app immediately with empty translations
    react: {
      useSuspense: false
    }
  });

// Load initial language asynchronously after app starts
setTimeout(async () => {
  try {
    const translation = await loadTranslations('en');
    i18n.addResourceBundle('en', 'translation', translation, true, true);
  } catch (error) {
    console.warn('Failed to load initial translations:', error);
  }
}, 0);

// Load French translations asynchronously when needed
i18n.on('languageChanged', async (language) => {
  if (!i18n.hasResourceBundle(language, 'translation')) {
    const translation = await loadTranslations(language);
    i18n.addResourceBundle(language, 'translation', translation, true, true);
    // Force re-apply language to trigger UI update
    i18n.changeLanguage(language);
  }
});

export default i18n;
